import PropTypes from 'prop-types';
import BsCard from '../../../atoms/bs-card';
import { className } from '../../../../utils/GlobalCssProxy';

/**
 * Module card
 */
const CardModule = ({ className: classNameProp, hypo10k, ...props }) => {
  const moduleClassName = className.string(hypo10k ? '' : 'h-100');

  const classes = classNameProp
    ? `${classNameProp} ${moduleClassName}`
    : moduleClassName;

  return <BsCard className={classes} {...props} />;
};

CardModule.propTypes = {
  className: PropTypes.string,
  hypo10k: PropTypes.bool
};

// Header
const Header = props => (
  <BsCard.Header
    as="h3"
    {...className('font-size-18', 'font-family-roboto', 'bg-transparent', 'pb-3')}
    {...props}
  />
);

CardModule.Header = Header;

// As-of date
const AsOfDate = ({ children }) => (
  <span
    {...className(
      'ml-2',
      'font-weight-normal',
      'font-size-12',
      'text-gray-500',
      'd-block',
      'd-md-inline'
    )}
  >
    As of {children}
  </span>
);

AsOfDate.propTypes = {
  children: PropTypes.node
};

CardModule.AsOfDate = AsOfDate;

// TODO: get rid of this component and handle display by passing BS classes (d-md-block) to the AsOfDate component
// As-of date, display: block @ medium
const AsOfDateMedBlock = ({ children }) => (
  <span
    {...className(
      'ml-2',
      'font-weight-normal',
      'font-size-12',
      'text-gray-500',
      'd-block',
      'd-lg-inline'
    )}
  >
    As of {children}
  </span>
);

AsOfDateMedBlock.propTypes = {
  children: PropTypes.node
};

CardModule.AsOfDateMedBlock = AsOfDateMedBlock;

// Body
const Body = ({ className: classNameProp, ...props }) => {
  const bodyClasses = className.string('py-3');
  const classesCombined = classNameProp
    ? `${classNameProp} ${bodyClasses}`
    : bodyClasses;
  return <BsCard.Body className={classesCombined} {...props} />;
};

Body.propTypes = {
  className: PropTypes.string
};

CardModule.Body = Body;

// Text
CardModule.Text = BsCard.Text;

// Footer
const Footer = ({ className: classNameProp, ...props }) => {
  const footerClasses = className.string('bg-transparent', 'pt-3');
  const classesCombined = classNameProp
    ? `${classNameProp} ${footerClasses}`
    : footerClasses;
  return <BsCard.Footer className={classesCombined} {...props} />;
};

Footer.propTypes = {
  className: PropTypes.string
};

CardModule.Footer = Footer;

export default CardModule;
